// eslint-disable-next-line import/no-extraneous-dependencies, no-restricted-imports
import $ from 'jquery';

import { renderReactRoot } from '@trello/component-wrapper';
import { ApolloProvider } from '@trello/graphql';
import { TrelloIntlProvider } from '@trello/i18n/provider';

import type { List } from 'app/scripts/models/List';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { boardModelIdToElementState } from 'app/src/boardModelIdToElementState';
import { LazyBoardListView } from 'app/src/components/BoardListView';
import { logBoardCanvasPerformanceMessage } from 'app/src/components/BoardListView/logBoardCanvasPerformanceMessage';
import { isBoardCanvasModernizationEnabled } from 'app/src/isBoardCanvasModernizationEnabled';
import type { ListView } from '../list/ListView';
import type { BoardView } from './BoardView';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const openListComposer = function (this: any) {
  return this.model.viewState.openListComposer();
};

export const scrollToList = function (this: BoardView, list: List) {
  if (!isBoardCanvasModernizationEnabled()) {
    return this.viewForList(list)?.el.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
    });
  }

  const listElement = boardModelIdToElementState.value.lists.get(
    list.get('id'),
  );
  if (!listElement) {
    return;
  }

  listElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
};

export const viewForList = function (
  this: BoardView,
  list: List,
): ListView | undefined {
  return this.listListView.viewForModel(list);
};

export const postListListRender = function (this: BoardView) {
  this.renderFilteringStatus();
  return DragSort.refreshListCardSortable();
};

export const renderLists = function (this: BoardView) {
  if (isBoardCanvasModernizationEnabled()) {
    logBoardCanvasPerformanceMessage('Mounting LazyBoardListView in Backbone');
    // we're rendering lists and list in react
    const mountPoint = $('.js-list-container', this.$el);
    const { unmount } = renderReactRoot(
      <TrelloIntlProvider>
        <ApolloProvider>
          <LazyBoardListView idBoard={this.model.get('id')} />
        </ApolloProvider>
      </TrelloIntlProvider>,
      mountPoint[0],
    );
    this.unmountLists = unmount;
  } else {
    // we're rendering lists in backbone still
    this.listListView.$el.toggleClass(
      'js-list-sortable',
      this.model.editable(),
    );
    $('.board-canvas', this.$el).append(this.listListView.el);
    // Render after adding because postListListRender is dumb and wants the
    // #board element to be in the DOM already
    this.listListView.render();
    this.listListView.delegateEvents();
  }

  return this;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortCommit = (e: any, ui: any) => ui.item.trigger('movelist', ui);
